import { MODAL_HEIGHT } from "@/constants";
import { ConfirmationDialog } from "@biom3/react";
import { CustomRive } from "../CustomRive";

type BonusQuestModalProps = {
  gameName: string;
  totalGemsGranted: number;
  onClose: () => void;
};

export const BonusQuestModal = ({
  gameName,
  totalGemsGranted,
  onClose,
}: BonusQuestModalProps) => (
  <ConfirmationDialog visible>
    <ConfirmationDialog.Content sx={{ height: MODAL_HEIGHT }}>
      <ConfirmationDialog.Content.Title>
        All quests completed, come back soon for more
      </ConfirmationDialog.Content.Title>
      <ConfirmationDialog.Content.Caption>
        {`You got a total of ${totalGemsGranted} gems for supporting ${gameName}.`}
        <br /> Stay tuned for more rewards and perks.
      </ConfirmationDialog.Content.Caption>
      <ConfirmationDialog.Content.RiveBox
        rc={<CustomRive src="/rive/spinning_gem.riv" />}
        testId="riveBox"
      />
      <ConfirmationDialog.Content.Button onClick={onClose}>
        Done
      </ConfirmationDialog.Content.Button>
      <ConfirmationDialog.Content.CloseButtCon onClick={onClose} />
    </ConfirmationDialog.Content>
  </ConfirmationDialog>
);
